export default __webpack_public_path__ + "static/media/Group 318.f0df8082.png";